module.exports = __webpack_public_path__ + "static/img/icon_class_pad.e4a2b57.png";


//////////////////
// WEBPACK FOOTER
// ./src/projects/hsbpc/views/welcome/components/img/icon_class_pad.png
// module id = W+Iv
// module chunks = 1